import React from "react";
import { Card, CardContent, Divider, MenuItem, Pagination, Radio, Switch, TextField, Grow, Grid, Autocomplete, Button, FormControlLabel, Checkbox, InputLabel, FormControl, TableCell, TableBody, TableHead, Table, TableRow, Modal } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goEditInflow, goEditOutflow, goToLogin, goToNewExpense, goToNewIncome } from "../../routes/Coordinator"
import axios from "axios";
import { useEffect } from "react";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import { Select as MuiSelect } from "@mui/material";
import OutlinedInput from '@mui/material/OutlinedInput';
import PrintIcon from '@mui/icons-material/Print';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import edit from '../../assets/images/edit.png';
import del from '../../assets/images/delete.png';
import print from '../../assets/images/print.png';
import view from '../../assets/images/view.png';
import up from '../../assets/images/up.png';
import Select from 'react-select'
import { SelectProvider } from "../Records/OutflowRecord/StyledOutflowRecord";

function UseQuery() {
  return new URLSearchParams(window.location.search)
}
const list = [
  {
    value: "",
    label: "Nenhum",
  },
  {
    value: "doc_number",
    label: "Número do Documento",
  },
  {
    value: "value",
    label: "Valor",
  },
  {
    value: "description",
    label: "Descrição",
  },
];
const margemList = [
  {
    value: "true",
    label: "Com Margem",
  },
  {
    value: "false",
    label: "Sem margem",
  },
];
const printList = [
  {
    value: "pdf",
    label: "Imprimir em PDF",
  },
  {
    value: "xls",
    label: "Imprimir em XLS",
  },
];
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2A858B',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const optionList = [
  {
    value: "cashbook",
    label: "Livro Caixa",
  },
  {
    value: "income_tax",
    label: "Imposto de Renda",
  },
  {
    value: "cash_outflow",
    label: "Despesa Fluxo de Caixa",
  },
];
const OutflowPage = () => {
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState([])
  const [providers, setProviders] = useState([])
  const [types, setTypes] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [id, setId] = useState(null)
  const [begin_release, setBegin_release] = React.useState(new Date())
  const [end_release, setEnd_release] = React.useState(new Date())
  const [option, setOption] = useState("")
  const [doctor_id, setDoctor_id] = useState("")
  const [formato, setFormato] = useState("")
  const [receipt, setReceipt] = useState(null)
  const [provider_id, setProvider_id] = useState("")
  const [type_id, setType_id] = useState("")
  const [search_key, setSearchKey] = useState("")
  const [search_value, setSearchValue] = useState("")
  const [rows, setRows] = useState([])
  const [valorTotal, setValorTotal] = useState([])
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [checkedrelease, setCheckedRelease] = useState(true);
  const [checkedprovidername, setCheckedProvidername] = useState(true);
  const [checkedcnpj, setCheckedCnpj] = useState(true);
  const [checkeddoc_number, setCheckedDoc_number] = useState(true);
  const [checkedoption, setCheckedOption] = useState(true);
  const [checkedtypename, setCheckedTypename] = useState(true);
  const [checkedvalue, setCheckedValue] = useState(true);
  const [checkeddescription, setCheckedDescription] = useState(true);
  const [checkedaccounting, setCheckedAccounting] = useState(true);
  const [checkedMargin, setCheckedMargin] = useState(true);
  const urlProviderId = UseQuery().get("provider_id")
  const urlProviderName = UseQuery().get("provider_name")


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const names = [{
    release: 'Data de Lançamento',
    providername: 'Fornecedor',
    cnpj: 'CNPJ',
    doc_number: 'Número do Documento',
    option: 'Opção',
    typename: 'Tipo',
    value: 'Valor',
    description: 'Descrição'
  }];
  const [personName, setPersonName] = React.useState([]);

  const releaseChange = (e) => {
    if (e.target.checked === true) {
      setCheckedRelease(e.target.checked)
    } else {
      setCheckedRelease(false)
    }
  }
  const providernameChange = (e) => {
    if (e.target.checked) {
      setCheckedProvidername(true)
    } else {
      setCheckedProvidername(false)
    }

  }
  const cnpjChange = (e) => {
    if (e.target.checked) {
      setCheckedCnpj(true)
    } else {
      setCheckedCnpj(false)
    }

  }
  const doc_numberChange = (e) => {
    if (e.target.checked) {
      setCheckedDoc_number(true)
    } else {
      setCheckedDoc_number(false)
    }

  }
  const optionChange = (e) => {
    if (e.target.checked) {
      setCheckedOption(true)
    } else {
      setCheckedOption(false)
    }

  }
  const typenameChange = (e) => {
    if (e.target.checked) {
      setCheckedTypename(true)
    } else {
      setCheckedTypename(false)
    }

  }
  const valueChange = (e) => {
    if (e.target.checked) {
      setCheckedValue(true)
    } else {
      setCheckedValue(false)
    }

  }
  const descriptionChange = (e) => {
    if (e.target.checked) {
      setCheckedDescription(true)
    } else {
      setCheckedDescription(false)
    }

  }
  const accountingChange = (e) => {
    if (e.target.checked) {
      setCheckedAccounting(true)
    } else {
      setCheckedAccounting(false)
    }

  }
  const SearchPDFUrl = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions.${formato}?doctor_id=${doctor_id}&nature=outflow`

    if (begin_release && end_release) {
      url = `${url}&begin_release=${new Date(begin_release).toLocaleDateString("fr-CA")}&end_release=${new Date(end_release).toLocaleDateString("fr-CA")}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (provider_id) {
      url = `${url}&provider_id=${provider_id}`
    }
    if (checkedMargin) {
      url = `${url}&margin=${checkedMargin}`
    }
    if (option) {
      url = `${url}&option=${option}`
    }
    if (search_key && search_value) {
      url = `${url}&${search_key}=${search_value}`
    }
    if (checkedrelease) {
      url = `${url}&columns[]=release`
    }
    if (checkedprovidername) {
      url = `${url}&columns[]=patient_or_provider_name`
    }
    if (checkedcnpj) {
      url = `${url}&columns[]=patient_or_provider_cpf_cnpj`
    }
    if (checkeddoc_number) {
      url = `${url}&columns[]=doc_number`
    }
    if (checkedoption) {
      url = `${url}&columns[]=option`
    }
    if (checkedtypename) {
      url = `${url}&columns[]=type_name`
    }
    if (checkedvalue) {
      url = `${url}&columns[]=value`
    }
    if (checkeddescription) {
      url = `${url}&columns[]=description`
    }
    if (checkedaccounting) {
      url = `${url}&columns[]=accounting`
    }
    return url
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const openModal = (id) => {
    setId(id)
    handleOpen()
  }
  const handleChange = (event, page) => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions?nature=outflow&page=${page}`

    if (begin_release && end_release) {
      url = `${url}&begin_release=${begin_release}&end_release=${end_release}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (provider_id) {
      url = `${url}&provider_id=${provider_id}`
    }
    if (option) {
      url = `${url}&option=${option}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };

  const filterType = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/types?nature=outflow`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setTypes(response.data.types)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };

  const Search = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions?nature=outflow&page=1`
    if (!doctor_id) {
      alert('Médico não pode ficar em branco');
      return
    }
    if (begin_release && end_release) {
      url = `${url}&begin_release=${new Date(begin_release).toLocaleDateString("fr-CA")}&end_release=${new Date(end_release).toLocaleDateString("fr-CA")}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (provider_id) {
      url = `${url}&provider_id=${provider_id}`
    }
    if (option) {
      url = `${url}&option=${option}`
    }
    if (search_key && search_value) {
      url = `${url}&${search_key}=${search_value}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
        setValorTotal(response.data.meta.total_value)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setDoctors(response.data.doctors)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Providers = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/providers`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        let responseData = response.data.providers.map((provider) => {
          return { value: provider.id, label: provider.name }
        })

        setProviders(responseData)
        setTotalPages(response.data.meta.total_pages)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const DeleteOutflows = (id) => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}`

    axios.delete(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        alert("Despesa deletada com sucesso.")
        Search()
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const newReceipt = () => {

    const formData = new FormData()

    formData.append("transaction[receipt]", receipt)
    axios.put(`${process.env.REACT_APP_BASE_URL}/transactions/${id}`, formData,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid")

        }
      })
      .then((resposta) => {
        handleClose()
        Search()
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )

  }
  useEffect(() => {
    if (localStorage.getItem("access-token") === null || localStorage.getItem("client") === null || localStorage.getItem("uid") === null) {
      alert(`Para continuar, efetue login ou registre-se.`)
      goToLogin(navigate)
    } else {
      Doctors()
      filterType()
      Providers()
    }
  }, [])
  const DeleteButton = (id) => {
    let resposta = window.confirm("Deseja remover esse registro?")
    if (resposta === true) {
      DeleteOutflows(id)
    }
  };

  const EditAccounting = (accounting, id) => {

    let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}/update_accounting`
    axios.patch(url, { transaction: { accounting } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        Search()
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const handleChangeChecked = (accounting, id) => {
    EditAccounting(accounting, id)
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent sx={{ paddingBottom: '0 !important' }}>
          <Typography variant="h3" sx={{ mb: 2 }}>Despesa</Typography>
          <Divider />

          <CardContent
            sx={{
              padding: "30px",
            }}
          >
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="Data inicial"
                    value={begin_release}
                    onChange={(newValue) => {
                      setBegin_release(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="Data final"
                    value={end_release}
                    onChange={(newValue) => {
                      setEnd_release(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  select
                  required
                  id="function"
                  label="Selecione o Médico"
                  onChange={(e) => setDoctor_id(e.target.value)}
                  value={doctor_id}
                  name={"doctor_id"}
                  type={"doctor_id"}
                >
                  {doctors.map((doctor) => (
                    <MenuItem key={doctor.id} value={doctor.id}>
                      {doctor.name}
                    </MenuItem>
                  ))}
                </TextField>
                {/* {doctor_id.length === 0 && <p>Médico obrigatório *</p>} */}
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <FormControl
                  sx={{ width: '100%' }}
                >
                  <SelectProvider>
                    <Select
                      placeholder={"Fornecedor"}
                      options={providers}
                      defaultValue={urlProviderId ? { value: urlProviderId, label: urlProviderName } : null}
                      onChange={(e) => setProvider_id(e.value)}
                    />
                  </SelectProvider>
                </FormControl>
                {/* <Autocomplete
                  disablePortal
                  placeholder={"Nenhum"}
                  options={providers}
                  onChange={(e, v) => setProvider_id(v?.value)}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Selecione o Fornecedor" />}
                /> */}
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  select
                  label="Opção"
                  id="outlined-required"
                  onChange={(e) => {
                    filterType(e.target.value)
                    setOption(e.target.value)
                  }}
                  value={option}
                  type={"option"}
                  name="role"
                >
                  {optionList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  select
                  label="Tipo"
                  id="function"
                  onChange={(e) => setType_id(e.target.value)}
                  value={type_id}
                  type={"type"}
                >
                  {types.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  sx={{ position: 'sticky' }}
                  fullWidth
                  select
                  id="function"
                  label="Selecione"
                  value={search_key}
                  onChange={(e) => setSearchKey(e.target.value)}
                >
                  {list.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  value={search_value}
                  noValidate
                  autoComplete="off"
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6} >
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  marginTop={1}>
                  <Button
                    onClick={() => Search()}
                    variant="contained"
                    color="primary"
                  >
                    <SearchOutlinedIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Pesquisar
                    </Typography>
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => goToNewExpense(navigate)}
                  >
                    <AddIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Cadastrar
                    </Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Impressão</Typography>
          <Divider />
          <CardContent
            sx={{
              padding: "30px",
            }}
          >
            <Grid container rowSpacing={2} columnSpacing={3} display={"flex"} alignItems={"center"}>
              <Grid item xs={12} md={12} lg={3}>
                <FormControl fullWidth sx={{ position: 'sticky' }}>
                  <InputLabel>Colunas</InputLabel>
                  <MuiSelect
                    multiple
                    value={personName}
                    // onChange={handleChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    <MenuItem><FormControlLabel control={<Checkbox onChange={releaseChange} checked={checkedrelease} />} value={"release"} label="Data de Lançamento" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={providernameChange} checked={checkedprovidername} />} value={"providername"} label="Fornecedor" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={cnpjChange} checked={checkedcnpj} />} value={"cnpj"} label="CNPJ" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={doc_numberChange} checked={checkeddoc_number} />} value={"doc_number"} label="Número do Documento" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={optionChange} checked={checkedoption} />} value={"option"} label="Opção" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={typenameChange} checked={checkedtypename} />} value={"typename"} label="Tipo" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={valueChange} checked={checkedvalue} />} value={"value"} label="Valor" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={descriptionChange} checked={checkeddescription} />} value={"description"} label="Descrição" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={accountingChange} checked={checkedaccounting} />} value={"accounting"} label="Contábil" /></MenuItem>
                  </MuiSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  sx={{ position: 'sticky' }}
                  fullWidth
                  select
                  id="function"
                  label="Margem"
                  onChange={(e) => setCheckedMargin(e.target.value)}
                >
                  {margemList.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  select
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  label="Formato de impressão"
                  onChange={(e) => setFormato(e.target.value)}
                  value={formato}
                  type={"formato"}
                  name="formato"
                >
                  {printList.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <Button target={'_blank'} href={SearchPDFUrl()} variant="contained" color="success" startIcon={<PrintIcon />} >
                  Imprimir
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </CardContent>
      </Card >
      {rows.length === 0 &&
        <CardContent
          sx={{
            padding: "30px",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Stack >
                <Alert severity="warning">Nenhum registro encontrado!</Alert>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      }
      {rows.length > 0 &&
        <Card variant="outlined">
          <CardContent>
            <Box>
              <Table
                aria-label="simple table"
                sx={{
                  mt: 3,
                }}>
                <TableHead>
                  <TableRow>
                    {checkedrelease && <TableCell className="release">
                      <Typography color="textSecondary" variant="h6">
                        Data de Lançamento
                      </Typography>
                    </TableCell>}
                    {checkedprovidername && <TableCell className="providername">
                      <Typography color="textSecondary" variant="h6">
                        Fornecedor
                      </Typography>
                    </TableCell>}
                    {checkedcnpj && <TableCell className="providercpf_cnpj">
                      <Typography color="textSecondary" variant="h6">
                        CNPJ
                      </Typography>
                    </TableCell>}
                    {checkeddoc_number && <TableCell className="doc_number">
                      <Typography color="textSecondary" variant="h6">
                        Número do Documento
                      </Typography>
                    </TableCell>}
                    {checkedoption && <TableCell className="option">
                      <Typography color="textSecondary" variant="h6">
                        Opção
                      </Typography>
                    </TableCell>}
                    {checkedtypename && <TableCell className="typename">
                      <Typography color="textSecondary" variant="h6">
                        Tipo
                      </Typography>
                    </TableCell>}
                    {checkedvalue && <TableCell className="value">
                      <Typography color="textSecondary" variant="h6">
                        Valor
                      </Typography>
                    </TableCell>}
                    {checkeddescription && <TableCell className="description">
                      <Typography color="textSecondary" variant="h6">
                        Descrição
                      </Typography>
                    </TableCell>}
                    {checkedaccounting && <TableCell sx={{ width: 2, padding: 0, minWidth: 0 }}>
                      <Typography color="textSecondary" variant="h6">
                        Contábil
                      </Typography>
                    </TableCell>}
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow sx={{ backgroundColor: '#D8D8D8' }}>
                    {checkedrelease && <TableCell></TableCell>}
                    {checkedprovidername && <TableCell></TableCell>}
                    {checkedcnpj && <TableCell></TableCell>}
                    {checkeddoc_number && <TableCell></TableCell>}
                    {checkedoption && <TableCell></TableCell>}
                    {checkedtypename && <TableCell></TableCell>}
                    {checkedvalue && <TableCell align="center"><b>{valorTotal.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</b></TableCell>}
                    {checkeddescription && <TableCell></TableCell>}
                    {checkedaccounting && <TableCell></TableCell>}
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </StyledTableRow>
                  {rows.map((row) => (
                    <StyledTableRow key={row.id}>
                      {checkedrelease && <StyledTableCell className="release" align="center">
                        {format(Date.parse(`${row.release} 12:00:00`), 'dd/MM/yyyy')}
                      </StyledTableCell>}
                      {checkedprovidername && <StyledTableCell align="center">
                        {row.provider.name}
                      </StyledTableCell>}
                      {checkedcnpj && <StyledTableCell align="center">
                        {row.provider.cpf_cnpj}
                      </StyledTableCell>}
                      {checkeddoc_number && <StyledTableCell align="center">
                        {row.doc_number}
                      </StyledTableCell>}
                      {checkedoption && <StyledTableCell align="center">

                        {row.option}

                      </StyledTableCell>}
                      {checkedtypename && <StyledTableCell align="center">

                        {row.type.name}

                      </StyledTableCell>}
                      {checkedvalue && <StyledTableCell align="center">

                        {row.value.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}

                      </StyledTableCell>}
                      {checkeddescription && <StyledTableCell align="center">

                        {row.description}

                      </StyledTableCell>}
                      {checkedaccounting && <StyledTableCell sx={{ width: 2, padding: 0, minWidth: 0 }} align="center">

                        <Switch size="small" defaultChecked color="success" checked={row.accounting} onChange={(e) => handleChangeChecked(e.target.checked, row.id)} />

                      </StyledTableCell>}
                      {row.receipt &&

                        <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}><Button sx={{ width: 2, padding: 0, minWidth: 0 }} target={'_blank'} href={`${process.env.REACT_APP_BASE_URL}${row.receipt}`}><img src={print}></img></Button></StyledTableCell>
                      }
                      {!row.receipt &&

                        <StyledTableCell sx={{ width: 5, padding: 0, minWidth: 0 }}></StyledTableCell>
                      }
                      <StyledTableCell align="center" sx={{ width: 5, padding: 0, minWidth: 0 }}><Button
                        sx={{ padding: 0, minWidth: 0 }} onClick={() => openModal(row.id)}
                      ><img src={up}></img></Button>

                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}>
                        <Button sx={{ padding: 0, minWidth: 0 }} onClick={() => goEditOutflow(navigate, row.id, row.provider.id, row.provider.name)}><img src={edit}></img></Button>
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}>
                        <Button sx={{ padding: 0, minWidth: 0 }} onClick={() => DeleteButton(row.id)}><img src={del}></img></Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <Box
                sx={{
                  marginTop: 5,
                  display: 'flex',
                  justifyContent: "flex-end"
                }}
              >
                <Stack spacing={2}>
                  <Pagination count={totalPages} onChange={handleChange} variant="outlined" color="primary" />
                </Stack>
              </Box>
            </Box>
          </CardContent>
        </Card>
      }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Upload de Recibo
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <FormControl sx={{ height: 40, width: "100%", marginLeft: 1, marginTop: 1, marginBottom: 2 }}>
              <TextField
                type="file"
                onChange={(e) => { setReceipt(e.target.files[0]) }}
              />
            </FormControl>
            <Typography
              sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}
            >Recibo não pode ser maior que 1 MB</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => newReceipt()} sx={{ marginTop: 1 }} variant="contained" color="success" startIcon={<AddIcon />}>
                Salvar
              </Button>
              <Button sx={{ marginTop: 1 }} onClick={handleClose} variant="outlined" >
                Fechar
              </Button>
            </Box>
          </Typography>
        </Box>
      </Modal>
    </Box >
  );
};

export default OutflowPage;